import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { FilterCollection, FilterMultiSelect, FilterValue, FilterValueCollection } from '@hub/generated/models';

@Component({
  selector: 'f-filterMultiSelect',
  templateUrl: './filterMultiSelect.component.html',
  styleUrls: ['./filterMultiSelect.component.scss']
})
export class FilterMultiSelectComponent implements OnInit,OnChanges {
  constructor() { }

  @Input()
  public filter: FilterMultiSelect;

  private _filterCollection: FilterCollection;

  @Input()  set filterCollection(f: FilterCollection) {
      this._filterCollection = f;
      this.value = this.getValue();
  }
  get filterCollection() {
      return this._filterCollection;
  }

  @Input()
  public emptyValueText: string = 'Select...';

  @Input()
  public inline: boolean = false;

  @Output()
  public ondataChange: EventEmitter<FilterValueCollection> = new EventEmitter<FilterValueCollection>();

  public value: FilterValue[];
  public columnName: string;
  public source: FilterValue[];

  public ngOnInit() {
    this.columnName = this.filter.ColumnName;
    this.source = this.filter.SourceValues;
    this.value = this.getValue();
  }

  ngOnChanges(){
    this.columnName = this.filter.ColumnName;
    this.source = this.filter.SourceValues;
    this.value = this.getValue();
  }

  public onChange(event) {
    let result: FilterValueCollection = new FilterValueCollection();
    result.ColumnName = this.columnName;
    result.List = this.value;

    this.ondataChange.emit(result);
  }

  private getValue(): FilterValue[]
  {
    if (!!this.filterCollection && !!this.filterCollection.List) {
      let values = this.filterCollection.List.filter((item) => item.ColumnName == this.columnName)[0];
      if (!!values && !!values.List && !!values.List.length)
        return values.List;
    }

    return null;
  }
}
